import React from "react";
import { Dialog } from "radix-ui";
import { Trans } from "react-i18next";
import { HiOutlineX } from "react-icons/hi";

import { I18nKeyType } from "@/i18n";
import { cn } from "@/utils/tailwind.ts";

type SvDialogCustomProps = React.HTMLAttributes<HTMLDivElement> & {
  trigger: React.ReactNode;
  titleKey?: I18nKeyType;
  descriptionKey?: I18nKeyType;
  children?: React.ReactNode | React.ReactNode[];
};

export const SvDialogCustom = ({
  trigger,
  titleKey,
  descriptionKey,
  className,
  children,
}: SvDialogCustomProps) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut fixed inset-0 bg-black/40" />
        <Dialog.Content
          className={cn(
            "data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut fixed top-1/2 left-1/2 flex max-h-[90%] w-[85%] -translate-x-1/2 -translate-y-1/2 flex-col gap-3 rounded-lg bg-white p-6 md:w-[70%] md:p-10 lg:w-auto",
            className,
          )}>
          <Dialog.Title className="w-full pr-7 text-xl font-semibold">
            <Trans i18nKey={titleKey} />
          </Dialog.Title>

          <Dialog.Description className="md:text-base md:leading-6">
            <Trans i18nKey={descriptionKey} />
          </Dialog.Description>

          {children}

          <Dialog.Close className="absolute top-6 right-6 flex h-6 w-6 cursor-pointer flex-row items-center justify-center p-0 md:top-10 md:right-10">
            <HiOutlineX className="h-5 w-5" />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
